import { render, staticRenderFns } from "./_rightPan.vue?vue&type=template&id=4c5f5f9a&scoped=true&"
import script from "./_rightPan.vue?vue&type=script&lang=js&"
export * from "./_rightPan.vue?vue&type=script&lang=js&"
import style0 from "./_rightPan.vue?vue&type=style&index=0&id=4c5f5f9a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5f5f9a",
  null
  
)

export default component.exports